<template lang="pug">
    footer.footer
        .footer__wrap

            .footer__link-set
                a.footer__link.footer__link--vk(:href='footer.social.vk.link', :title='footer.social.vk.title', rel='noopener', target='_blank')
                    svg(xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100')
                        path(d='M94.19.29H5.81A5.52 5.52 0 0 0 .29 5.81v88.38a5.52 5.52 0 0 0 5.52 5.52h88.38a5.52 5.52 0 0 0 5.52-5.52V5.81A5.52 5.52 0 0 0 94.19.29zm-13.2 71.38H73.7c-2.78 0-3.59-2.22-8.54-7.17-4.32-4.17-6.18-4.72-7.26-4.72-1.47 0-1.91.41-1.91 2.5v6.54c0 1.79-.58 2.84-5.21 2.83-7.73 0-16.21-4.7-22.23-13.36-9.03-12.67-11.5-22.26-11.5-24.19 0-1.08.42-2.06 2.5-2.06h7.29c1.86 0 2.56.82 3.26 2.84 3.56 10.39 9.57 19.47 12.04 19.47.93 0 1.35-.43 1.35-2.78l.01-10.74c-.27-4.94-2.89-5.35-2.89-7.11 0-.82.7-1.68 1.86-1.68l11.46.01c1.55 0 2.08.83 2.08 2.68L56 49.19c0 1.54.67 2.09 1.13 2.09.93 0 1.7-.54 3.4-2.24 5.26-5.87 8.97-14.9 8.97-14.9a3.15 3.15 0 0 1 3.17-2.06h7.29c2.2 0 2.67 1.14 2.2 2.68-.93 4.25-9.82 16.76-9.82 16.76-.77 1.24-1.08 1.85 0 3.24.77 1.08 3.32 3.25 5.02 5.26 3.13 3.52 5.49 6.5 6.15 8.55.61 2.06-.44 3.1-2.52 3.1z' fill-rule='evenodd' clip-rule='evenodd')

                a.footer__link.footer__link--tl(:href='footer.social.telegram.link', :title='footer.social.telegram.title', rel='noopener', target='_blank')
                    svg(xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100')
                        path(d='M94.19.29H5.81A5.52,5.52,0,0,0,.29,5.81V94.19a5.52,5.52,0,0,0,5.52,5.52H94.19a5.52,5.52,0,0,0,5.52-5.52V5.81A5.52,5.52,0,0,0,94.19.29Zm-11.79,26c-2.19,10.27-8,38.84-10.42,50.12a3.21,3.21,0,0,1-2,2.33,3.31,3.31,0,0,1-3.06-.4c-5.6-4-15.47-11.23-15.47-11.23l-8.56,8.08a2.38,2.38,0,0,1-2.24.57A2.41,2.41,0,0,1,39,74.13c-2.1-6.17-6.11-18.28-6.11-18.28s-8.59-2.73-15.13-4.68a2.27,2.27,0,0,1-.14-4.32c14.59-5.4,50.28-18.79,61.86-23.08a2.22,2.22,0,0,1,2.21.39A2.16,2.16,0,0,1,82.4,26.25Z')
                        path(d='M36.49,54.31l4.64,15.31,1-9.69L70.31,34.54a.76.76,0,0,0,.09-1,.79.79,0,0,0-1-.18Z')

                a.footer__link.footer__link--mail(:href='footer.social.mail.link')
                    svg(xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 100 100')
                        path(d='M24.8 37.1v25.8L38.3 50zM56.3 55.2a9.3 9.3 0 0 1-6.3 2.6c-2.3 0-4.6-.9-6.3-2.6L42 53.5 28.5 66.3h43L58.1 53.5l-1.8 1.7zM47.1 51.5a4 4 0 0 0 2.9 1.2c1 0 2.1-.4 2.9-1.2l18.6-17.9h-43l18.6 17.9zM75.2 62.9V37.1L61.7 50z')
                        path(d='M94.4 0H5.6A5.6 5.6 0 0 0 0 5.6v88.9c0 3.1 2.5 5.6 5.6 5.6h88.9c3.1 0 5.6-2.5 5.6-5.6V5.6C100 2.5 97.5 0 94.4 0zM80.2 68.9c0 .7-.3 1.3-.7 1.8s-1.1.7-1.8.7H22.3c-.7 0-1.3-.3-1.8-.7s-.7-1.1-.7-1.8V31.1c0-.7.3-1.3.7-1.8.5-.5 1.1-.7 1.8-.7h55.5c.7 0 1.3.3 1.8.7.5.5.7 1.1.7 1.8v37.8zM56.3 55.2z')


            .footer__content
                .footer__copyright(v-html='footer.copyright')
                .footer__legal-links
                    a.footer__legal-link(
                        v-for="item in footer.legalLinks",
                        :key="",
                        :href='item.link',
                        target='_blank',
                        :aria-label="`Скачать документ: ${item.text}`",
                        v-html="item.text"
                    )

                .footer__llc(v-if='$route.name === "Contacts"', v-html='footer.extraContactsText')


</template>

<script>
const Menu = () => import('@/components/Menu.vue');
import footer from '../assets/data/footer.json';

export default {
    name: 'Footer',

    data() {
        return {
            footer
        };
    },

    mounted() {},

    components: {
        Menu
    },

    methods: {}
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';

:root {
    --vh: 5.68px;
}

.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-footer-bg);
    min-height: 2.86em;
    color: var(--color-main-text);

    &__wrap {
        position: relative;
        width: 100%;
        max-width: 1920px;
        padding: 0.52em 10em 0.5em;
        margin-right: auto;
        margin-left: auto;

        @media (--viewport-tablet) {
            padding-top: 1.4em;
            padding-bottom: 1.6em;
            padding-left: 3vw;
            padding-right: 3vw;
        }

        @media (--viewport-mobile-m) {
            padding-left: 3vw;
            padding-right: 3vw;
        }
    }

    &__content {
        $draft-margin-left: 324px;
        $margin-10em-in-px: 210px;

        width: 100%;
        max-width: #{1920px - $draft-margin-left * 2};
        margin-right: auto;
        margin-left: auto;

        @media (--viewport-tablet) {
            padding-right: 7em;
        }

        @media (--viewport-mobile-m) {
            padding-right: 0;
        }
    }

    &__link-set {
        position: absolute;
        top: 50%;
        right: 4.7em;
        transform: translateY(-50%);

        @media (--viewport-mobile-m) {
            position: relative;
            transform: none;
            top: unset;
            right: unset;
            // top: 0.7em;
            // right: 3vw;
            margin-bottom: 1em;
            text-align: center;
        }
    }

    &__copyright,
    &__legal-links,
    &__llc {
        opacity: 0.3;
        font-size: 0.76em;

        @media (--viewport-mobile-m) {
            font-size: 0.82em;
        }
    }

    &__llc {
        font-size: 0.6em;
        margin-top: 0.8em;
    }

    &__copyright {
        width: 100%;
        text-wrap: balance;

        @media (--viewport-mobile-m) {
            margin-bottom: 1em;
        }
    }

    &__legal-link {
        display: inline-block;
        font-weight: inherit;
        text-decoration: none;
        margin-right: 3.25em;
        background-image: url("data:image/svg+xml;utf8,%3Csvg width='400' height='10' preserveAspectRatio='xMidYMax meet' xmlns='http://www.w3.org/2000/svg'%3E%3Cline x1='25%' y1='90%' x2='50%' y2='90%' stroke='%23000000' stroke-width='2' vector-effect='non-scaling-stroke' /%3E%3Cline x1='75%' y1='90%' x2='100%' y2='90%' stroke='%23000000' stroke-width='2' vector-effect='non-scaling-stroke' /%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-size: 400% 0.5em;
        background-position: 66.67% 100%;
        transition: opacity 0.15s ease, background-position 0.15s ease;

        @media (--viewport-mobile-m) {
            margin-right: 2.25em;

            &:last-of-type {
                margin-right: 0;
            }
        }

        @media (hover: hover) {
            &:hover,
            &:focus {
                opacity: 0.5;
                color: inherit;
                background-position: 33.33% 100%;
                transition-duration: 0.35s;
            }
        }
    }

    &__link {
        width: 1.38em;
        height: 1.38em;
        display: inline-block;
        opacity: 0.3;
        margin-right: 0.86em;

        @media (--viewport-mobile-m) {
            width: 2em;
            height: 2em;
            margin-right: 0.86em;
        }

        &:last-child {
            margin-right: 0;
        }

        &:hover,
        &:focus {
            opacity: 1;
        }

        svg {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
